<template>
  <div class="container">
    <template>
      <div class="addRoute">
        <div class="addRoute__header">
          <h1 class="medium-title">{{ routeId ? `Edit Route` : `Add New Route` }}</h1>
        </div>
        <div v-if="!isLoadingAll" class="addRoute__body">
          <!-- Left Content -->
          <div class="addRoute__body__left">
            <div class="addRoute__body__left__form">
              <!-- Route -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Route</h1>
                <div class="addRoute__body__left__form__container__item">
                  <a-input :label="`Name`" :value.sync="model.route" :error.sync="vuelidateOptions.route.error"
                    :ref="vuelidateOptions.route.ref"/>
                </div>
                <div class="addRoute__body__left__form__container__item">
                  <a-textarea :label="`Description ( Optional )`" :value.sync="model.description" :error.sync="vuelidateOptions.description.error"
                    :ref="vuelidateOptions.description.ref"/>
                </div>
                <div class="addRoute__body__left__form__container__item">
                  <a-textarea :label="`Content Restriction ( Optional )`" :value.sync="model.restriction" :error.sync="vuelidateOptions.restriction.error"
                    :ref="vuelidateOptions.restriction.ref"/>
                </div>
              </div>
              <!-- Bus Details -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Bus Details</h1>
                <div class="busDetail">
                  <div class="addRoute__body__left__form__container__route busDetail__item left">
                    <div class="addRoute__body__left__form__container__item">
                      <a-select-dropdown :label="`Categories`" :options="options.categories" :value.sync="model.category" :error.sync="vuelidateOptions.category.error"
                        @addNew="toggleModal('category')" :insertAddNew="`true`"
                        :ref="vuelidateOptions.category.ref"/>
                    </div>
                  </div>
                  <div class="addRoute__body__left__form__container__item busDetail__item">
                    <a-input :label="`Estimated Impression per day`" :value.sync="model.impression"/>
                  </div>
                  <div class="addRoute__body__left__form__container__route busDetail__item left">
                    <div class="addRoute__body__left__form__container__item" >
                      <a-select-dropdown :label="`Brand`" :options="options.brands" :value.sync="model.brand" 
                        :error.sync="vuelidateOptions.brand.error" @addNew="toggleModal('brand')" :insertAddNew="`true`" :ref="vuelidateOptions.brand.ref"/>
                    </div>
                  </div>
                  <div class="addRoute__body__left__form__container__item busDetail__item">
                    <a-input :label="`Trip Distance in km`" :value.sync="model.distance"/>
                  </div>
                </div>
              </div>
              <!-- Map and Waypoint -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Map and Waypoint</h1>
                <div class="addRoute__body__left__form__container__file">
                  <div :class="[vuelidateOptions.kmlFileData.error && model.kmlFileName == null ? 'upload-wrapper-warning' :'']" :ref="vuelidateOptions.kmlFileData.ref">
                    <div class="upload-wrapper">
                      <div class="upload-button">
                        <input type="file" accept=".kml" @change="getFile" ref="fileUpload" style="display: none;"/>
                        <button type="button" :class="['secondary', 'btn-small', 'btn-checkout-large', isSaving ? 'disabled' : '']" @click="launchFilePicker">Upload Route</button>
                      </div>
                      <div class="file_name">
                        <label class="label" v-if="!model.kmlFileName">Upload your .kml file</label>
                        <label class="label" v-else>{{model.kmlFileName}}</label>
                        <i v-if="model.kmlFileName" @click="cancelFile()" class="adx-ic_cancel"></i>
                      </div>
                      <div class="file_status" v-if="kmlLoading != null">
                        <span v-if="kmlLoading" class="is_loading">Loading...</span>
                        <span v-if="!kmlLoading && kmlSuccess" class="is_success">Uploaded</span>
                        <span v-if="!kmlLoading && !kmlSuccess" class="is_error">Error</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="vuelidateOptions.kmlFileData.error && model.kmlFileData == null" class="error-message">{{vuelidateOptions.kmlFileData.error}}</div>
                </div>
                <div class="addRoute__body__left__form__container__route" :key="waypointKey">
                  <div v-for="(obj, index) in model.waypointLocation" :key="index" class="addRoute__body__left__form__container__route__detail">
                    <div class="top size">
                      <div class="waypointWrapper">
                        <div class="waypoint" >
                          <a-select-dropdown :label="`Waypoint`" :options="options.waypoints" :value.sync="obj.waypoint"
                            @selected="showWaypoint($event, index, obj)" :ref="vuelidateOptions.waypointLocation.ref.waypoint" @addNew="showWaypoint($event, index)"
                            :insertAddNew="`true`" :error.sync="vuelidateOptions.waypointLocation.error[index].waypoint"/>
                        </div>
                        <div class="location">
                          <a-input :label="`Location Name`" :value.sync="obj.location" :ref="vuelidateOptions.waypointLocation.ref.location"
                            :error.sync="vuelidateOptions.waypointLocation.error[index].location"/>
                        </div>
                      </div>
                      <div class="icon-wrapper"><i @click="deleteWayPoint(index)" class="icon-deleted"></i></div>
                    </div>
                  </div>
                  <div class="line-wrapper"><hr class="line" /></div>
                  <div class="button"><button @click="addWayPoint" class="new">Add new</button></div>
                </div>
              </div>
              <!-- Images -->
              <div class="addRoute__body__left__form__container">
                <h1 class="subhead">Images</h1>
                <div v-for="(image, index) in model.images" :key="index" class="addRoute__body__left__form__container__images__image">
                  <div class="upload-wrapper">
                    <div class="top">
                      <div class="upload-button">
                        <input type="file" accept="image/*" @change="getFileImage($event, image, index)" :name="`fileUpload`+index"
                          :id="`fileUpload`+index" style="display: none;"/>
                        <label :for="`fileUpload`+index" class="button-input">Add Image</label>
                      </div>
                      <div v-if="image.url" class="file-image">
                        <img :src="image.url" />
                      </div>
                      <div class="file-name">
                        <span class="image_name">
                          <label>{{image.name}}</label>
                          <i v-if="image.name" @click="cancelImage(index)" class="adx-ic_cancel"></i>
                        </span>
                        <div class="image_status" v-if="imageLoadings[index] != null">
                          <span v-if="imageLoadings[index]" class="is_loading">Loading...</span>
                          <span v-if="!imageLoadings[index] && image.isSuccess" class="is_success">Uploaded</span>
                          <span v-if="!imageLoadings[index] && !image.isSuccess" class="is_error">Error</span>
                        </div>
                      </div>
                    </div>
                    <div class="bottom">
                      <div>
                        <a-checkbox :label="`Set as featured image`" :valueLabel.sync="image.isFeatured" :value.sync="image.isFeatured"
                          :inputId="index" @buttonClicked="buttonClicked(image)"/>
                      </div>
                    </div>
                  </div>
                  <div class="icon-wrapper">
                    <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                  </div>
                </div>
                <div class="line-wrapper"><hr class="line" /></div>
                <div class="button"><button @click="addImage(model.images)" class="new">Add new</button></div>
              </div>
              <!-- Placement -->
              <div class="addRoute__body__left__form__placement">
                <h1 class="subhead">Placement</h1>
                <div class="addRoute__body__left__form__placement__items">
                  <table>
                    <thead class="none">
                      <tr>
                        <td class="header subhead">PLACEMENT</td>
                        <td class="header subhead center-title">INIT. QUANTITY</td>
                        <td class="header subhead center-title">ACTIVE</td>
                        <td class="header subhead center-title">PUBLIC</td>
                      </tr>
                    </thead>
                    <tbody v-if="!isLoadingAll && !isEmpty">
                      <tr v-for="(item, index) in this.model.items" :key="index" class="content">
                        <td class="placement subhead">{{item.placements}}</td>
                        <td class="quantity subhead">{{item.quantity}}</td>
                        <td class="check-icon subhead">
                          <span v-if="item.active" class="check">
                            <img src="/img/adxicon/ic-add2.png" alt />
                          </span>
                          <span v-else class="none">-</span>
                        </td>
                        <td class="check-icon subhead">
                          <span v-if="item.public" class="check">
                            <img src="/img/adxicon/ic-add2.png" alt />
                          </span>
                          <span v-else class="none">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="emptyState" v-if="model.items.length < 1">
                    <a-empty-selection title="No Placement to Show" subtitle="There is no one placement linked to this route"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Content -->
          <div class="addRoute__body__right">
            <div class="addRoute__body__right__status__container">
              <h1 class="subhead">Ownership</h1>
              <div class="dropdown">
                <a-single-search-dropdown v-if="options.users.length > 0" :label="`Owner`" :optionsParam="options.users" :value.sync="$v.model.owner.$model"
                  :size="'size'" :ref="vuelidateOptions.owner.ref" :error.sync="vuelidateOptions.owner.error"/>
              </div>
            </div>
            <div class="button"><button class="btn-large primary" @click="save">Save<a-loading-scnd-white v-if="saveLoading" /></button></div>
          </div>
        </div>
        <!-- Modal -->
        <a-modal v-if="isShowModalCategories" :title="`Add New Categories`" @modal-close="toggleModal('category')" type="small">
          <div class="addRoute__modal__category" slot="content">
            <a-input class="input" :label="`Categories Name`" :value.sync="categoryModel.newCategory"
              :ref="vuelidateCategoryOptions.newCategory.ref" :error.sync="vuelidateCategoryOptions.newCategory.error" @keypress.enter.native="submitNew('categoryModel', $event)"
            />
            <div class="buttons">
              <button class="btn-regular secondary" @click="toggleModal('category')">Cancel</button>
              <button class="btn-large primary save" @click="submitNew('categoryModel', $event)">Save<a-loading-scnd-white v-if="modalLoading"/></button>
            </div>
          </div>
        </a-modal>
        <a-modal v-if="isShowModalBrand" :title="`Add New Brand`" @modal-close="toggleModal('brand')" type='small'>
          <div class="addRoute__modal__category" slot="content">
            <a-input class="input" :label="`Brand Name`" :value.sync="brandModel.newBrand" :ref="vuelidateBrandOptions.newBrand.ref" :error.sync="vuelidateBrandOptions.newBrand.error" 
              @keypress.enter.native="submitNew('brandModel', $event)"/>
            <div class="buttons">
              <button class="btn-regular secondary" @click="toggleModal('brand')">Cancel</button>
              <button class="btn-large primary save" @click="submitNew('brandModel', $event)">Save<a-loading-scnd-white v-if="modalLoading"/></button>
            </div>
          </div>
        </a-modal>
        <div v-for="(wayPoint, index) in model.waypointLocation" :key="index">
          <a-modal v-if="isShowModalWayPoint[index]" :title="`Add Way Point`" @modal-close="showWaypoint($event, index)" type='small'>
            <div class="addRoute__modal__way-point"  slot="content">
              <a-input class="input" :label="`Waypoint Name`" :value.sync="waypointModel.newWaypoint" :ref="vuelidateWaypointOptions.newWaypoint.ref"
                :error.sync="vuelidateWaypointOptions.newWaypoint.error" @keypress.enter.native="submitNew('waypointModel', $event, index)"/>
              <div class="buttons">
                <button class="btn-regular secondary" @click="showWaypoint($event, index)">Cancel</button>
                <button class="btn-large primary save" @click="submitNew('waypointModel', $event, index)">Save<a-loading-scnd-white v-if="modalLoading" /></button>
              </div>
            </div>
          </a-modal>
        </div>
      </div>
    </template>
    <template v-if="isLoadingAll">
      <div class="container__loadingWrapper">
        <slot name="loading"/>
        <a-loading/>
      </div>
    </template>
  </div>
</template>	

<script>
import * as validationLib from "@/lib/validation/"
import triggerValidation from "@/lib/triggerValidation"
import { mapListFilter, fromArrayKeys } from '@/lib/transformer'
import { globalMixins } from '@/lib/mixins/globalMixins'
import { mapGetters } from "vuex"
import { restEdge } from "@/api/edgeUrls"
import api from "@/api"
import { required, minLength, maxLength, alphaNum, alpha, requiredIf } from 'vuelidate/lib/validators'
import { AInput, ACheckbox, ATextArea, ASelectDropdown, ASingleSearchDropdown, ALoadingPrimary,
  ALoadingSecondary, ALoadingSecondaryWhite, AEmptySelection, AModal
} from "ui-kit-v1"

const { helpers, validate } = validationLib;


export default {
  name: "adx-add-route",
  components: {
    "a-modal": AModal,
    "a-loading": ALoadingPrimary,
    "a-loading-scnd-white": ALoadingSecondaryWhite,
    "a-empty-selection": AEmptySelection,
    "a-input": AInput,
    "a-checkbox": ACheckbox,
    "a-textarea": ATextArea,
    "a-select-dropdown": ASelectDropdown,
    "a-single-search-dropdown": ASingleSearchDropdown,
  },
  mixins: [ globalMixins ],
  props: {

  },
  data() {
    return {
      optionPromise: null,
      formPromise: null,
      waypointKey: false,
      isEmpty: false,
      isLoadingAll: false,
      isSaving: true,
      isShowModalCategories: false,
      isShowModalWayPoint: [],
      isShowModalBrand: false,
      kmlLoading: null,
      kmlSuccess: false,
      modalLoading: false,
      saveLoading: false,
      size : "small",
      userInputted: true,
      errorLocation:[],
      imageLoadings: [],
      routeId: null,
      model: {
        impression: 0,
        distance: 0,
        route: null,
        description: null,
        category: null,
        restriction: null,
        brand: null,
        kmlFileName: null,
        kmlFileData: null,
        kmlFileId: null,
        kmlFile: null,
        imageIds: [],
        images: [
          {
            id: null,
            name: null,
            image: null,
            isFeatured: null,
            url: null
          }
        ],
        waypointLocation: [
          {
            waypoint: null,
            location: null
          }
        ],
        owner: null,
        items: []
      },
      brandModel: {
        newBrand: null
      },
      categoryModel: {
        newCategory: null
      },
      waypointModel: {
        newWaypoint: null
      },
      vuelidateOptions: {
        route: {
          field: 'name',
          error: null,
          ref: 'route'
        },
        description: {
          error: null,
          ref: 'description'
        },
        restriction: {
          error: null,
          ref: 'restriction'
        },
        category: {
          error: null,
          ref: 'category'
        },
        brand: {
          error: null,
          ref: 'brand'
        },
        kmlFileData: {
          field: 'kml file',
          error: null,
          ref: 'kmlFileData'
        },
        waypointLocation: {
          field: {
            waypoint: 'waypoint',
            location: 'location name'
          },
          error: [
            {
              waypoint: null,
              location: null
            }
          ],
          ref: {
            waypoint: 'waypoint',
            location: 'location'
          },
          pair: 2
        },
        owner: {
          error: null,
          ref: 'owner'
        },
      },
      vuelidateBrandOptions: {
        newBrand: {
          field: 'brand',
          error: null,
          ref: 'newBrand'
        }
      },
      vuelidateCategoryOptions: {
        newCategory: {
          field: 'category',
          error: null,
          ref: 'newCategory'
        }
      },
      vuelidateWaypointOptions: {
        newWaypoint: {
          field: 'waypoint',
          error: null,
          ref: 'newWaypoint'
        }
      },
      options: {
        categories: [],
        waypoints: [],
        users: [],
        brands: []
      }
    }
  },
  validations: {
    model: {
      route: { required, minLength: minLength(3), maxLength: maxLength(50) },
      description: { maxLength: maxLength(256) },
      restriction: { maxLength: maxLength(256) },
      category: { required },
      brand: { required },
      kmlFileData: { required },
      waypointLocation: {
        $each: {
          waypoint: { 
            requiredIf: requiredIf((obj) => obj.location != null)
          },
          location: {
            requiredIf: requiredIf((obj) => obj.waypoint != null)
          }
        }
      },
      owner: { required },
    },
    brandModel: {
      newBrand: { required, minLength: minLength(3), maxLength: maxLength(50) }
    },
    categoryModel: {
      newCategory: { required, minLength: minLength(3), maxLength: maxLength(50) },
    },
    waypointModel: {
      newWaypoint: { required, minLength: minLength(3), maxLength: maxLength(100) },
    }
  },
  computed: {
    ...mapGetters({
      user: "account",
      token: "token"
    })
  },
  apollo: {

  },
  watch: {

  },
  beforeCreate() {

  },
  async created() {
    if (this.$route.params.hasOwnProperty('id')) this.routeId = this.$route.params.id
  },
  beforeMount() {

  },
  async mounted() {
    this.$nextTick(async () => {
      if (this.routeId) await this.getFormData()
    })
    await this.getFormOptions()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    submitNew(type, event, index = null) {
      if (type === 'categoryModel') {
        event.key != "enter" ? this.createNewOption(type, this.categoryModel.newCategory, this.vuelidateCategoryOptions, 'createCategory') : this.createNewOption('categoryModel', event.target.value, this.vuelidateCategoryOptions, 'createCategory')
      } else if (type === 'waypointModel') {
        event.key != "enter" ? this.createNewOption(type, this.waypointModel.newWaypoint, this.vuelidateWaypointOptions, 'createInterest', index) : this.createNewOption('waypointModel', event.target.value, this.vuelidateWaypointOptions, 'createInterest', index)
      } else if (type === 'brandModel') {
        event.key != "enter" ? this.createNewOption(type, this.brandModel.newBrand, this.vuelidateBrandOptions, 'createBrand') : this.createNewOption('brandModel', event.target.value, this.vuelidateBrandOptions, 'createBrand')
      }
    },
    async createNewOption(type, value, options, url, index = null) {
      this.$v.$touch()

      if (this.$v[type].$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v[type], options, this.$refs)
        options[key].error = message
        if (element && type !== 'waypointModel') {
          this.$nextTick(function() {
            element.scrollIntoView()
          })
        }
      } else {
        const { data, status, statusText } = await api.post(restEdge[url], { title: value }, { needToken: true, useRestEdge: true})
  
        if (status == 200) {
          this.modalLoading = false
          let element

          if (type === 'categoryModel') {
            this.options.categories.push({ id: data.id, title: data.title, label: data.title, value: data.id })
            this.isShowModalCategories = false
            element = this.$refs.category.$el
            this.$nextTick(function() {
              this.model.category = data.id
              element.scrollIntoView()
            })
          } else if (type === 'brandModel') {
            this.options.brands.push({ id: data.id, title: data.title, label: data.title, value: data.id })
            this.isShowModalBrand = false
            element = this.$refs.brand.$el
            this.$nextTick(function() {
              this.model.brand = data.id
              element.scrollIntoView()
            })
          } else if (type === 'waypointModel') {
            this.isShowModalCategories = false
            this.isShowModalWayPoint[index] = false
            this.options.waypoints.push({ id: data.id, title: data.title, label: data.title, value: data.id })
            element = this.$refs.waypoint[index].$el
            this.$nextTick(function() {
              this.model.waypointLocation[index].waypoint = data.id
              element.scrollIntoView()
            })
          }

        } else {
          this.showNotificationAlert('Error', statusText, 'danger')
        }
      }
    },
    async saveKMLFile(){
      this.kmlLoading = true;

      let formData = new FormData();
      formData.append("file", this.model.kmlFileData);
      formData.append("name", this.model.kmlFileData.name);
      const response = await api.post(restEdge.uploadFile, formData, { 
        needToken: true, 
        useRestEdge: true,
        headers: {'Content-Type': 'multipart/form-data'} 
      });
  
      this.kmlLoading = false;
      if(response.status == 200){
        this.kmlSuccess = true;
        this.model.kmlFileId = parseInt(response.data.id)
      } else {
        this.kmlSuccess = false;
        this.showNotificationAlert('Error', 'KML failed to save', 'danger')
      }
    },
    addWayPoint() {
      this.model.waypointLocation.push({ location: null, waypoint: null })
      this.vuelidateOptions.waypointLocation.error.push({ location: null, waypoint: null })
      this.isShowModalWayPoint.push(false)
    },
    deleteWayPoint(index) {
      if (this.model.waypointLocation.length > 1) {
        this.model.waypointLocation.splice(index, 1)
        this.isShowModalWayPoint.splice(index, 1)
      } else {
        this.showNotificationAlert('Delete Error', 'Oops data can not be deleted!', 'danger')
      }
    },
    cancelFile() {
      this.model.kmlFileName = null;
      this.kmlLoading = null
    },
    async getFile(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.model.kmlFile = e.target.result
        };
        reader.readAsDataURL(input.files[0]);
        this.model.kmlFileName = input.files[0].name;
        this.model.kmlFileData = input.files[0];
        await this.saveKMLFile()
      }
    },
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    toggleModal(type) {
      if (type === 'category') {
        this.isShowModalCategories = !this.isShowModalCategories
        this.categoryModel.newCategory = null
        this.vuelidateCategoryOptions.newCategory.error = null
      } else if (type === 'brand') {
        this.isShowModalBrand = !this.isShowModalBrand
        this.brandModel.newBrand = null
        this.vuelidateBrandOptions.newBrand.error = null
      }
    },
    getFileImage(event, image, index) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateImageFile(input.files[0]);
        if (!validated_data.is_valid) {
          this.showNotificationAlert("Error", validated_data.message, "danger")
        } else {
          reader.onload = e => {
            image.url = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];
          this.saveImage(input.files[0], image, index);
        }
      }
    },
    async saveImage(fileData, image, index) {
      image.loading = true;
      this.$set(this.imageLoadings, index, true);
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("name", fileData.name);
      const result = await api.post(restEdge.uploadFile, formData, {
        needToken: true,
        useRestEdge: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      await this.$nextTick();
      this.$set(this.imageLoadings, index, false);
      if(!result.errors){
        image.isSuccess = true;
        image.id = parseInt(result.data.id);
        this.model.imageIds.push({id:parseInt(result.data.id)})
      } else {
        image.isSuccess = false;
      }
    },
    cancelImage(index) {
      this.model.images[index].id = null;
      this.model.images[index].name = null;
      this.model.images[index].image = null;
      this.model.images[index].isFeatured = null;
      this.model.images[index].url = null;
      this.$set(this.imageLoadings, index, null);
    },
    validateImageFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true };
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/);
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false;
          data.message = "Unsupported file type";
          return data;
        }
      } else {
        data.is_valid = false;
        data.message = "Unsupported file type";
        return data;
      }
      if (file.size > maxSize) {
        data.is_valid = false;
        data.message = `File too large.`;
        return data;
      }
      const filename = file.name.split(".")[0];
      if (filename.length > 100) {
        data.is_valid = false;
        data.message = "File name is too long. Maximum size 100 character";
        return data;
      }

      if (filename.includes("/")) {
        data.is_valid = false
        data.message = "File name has forbidden character"
        return data
      }
      return data;
    },
    addImage(images) {
      images.push({
        id: null,
        name: null,
        image: null,
        isFeaturedurl: null,
      })
    },
    deleteImages(image, index) {
      image.splice(index, 1)
      this.imageLoadings.splice(index, 1)
    },
    async save() {
      this.$v.$touch()

      if (this.$v.model.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, this.vuelidateOptions, this.$refs)
        if (collection) {
          this.vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
        } else {
          this.vuelidateOptions[key].error = message
        }
        if (element) {
          this.$nextTick(function() {
            element.scrollIntoView()
          })
        }

      } else {
        this.saveLoading = true

        const body = {
          title: this.model.route,
          description: this.model.description,
          category: this.model.category,
          forbiddenAds: this.model.forbiddenAds,
          owner: await this.options.users.filter(user => user.id === this.model.owner)[0].id,
          brand: this.model.brand,
          impression: parseInt(this.model.impression),
          routeDetails: await this.model.waypointLocation.map(wp => ({ location: wp.location, pointInterest: wp.waypoint })).filter(wp => wp.location != null),
          contents: await this.model.images.map(image => ({ id: image.id, is_featured: image.isFeatured })).filter(image => image.id != null),
          fileRoute: this.model.kmlFileId,
          distance: this.model.distance
        }

        let response

        if (this.routeId) {
          response = api.patch(restEdge.updateRoute(this.routeId), body, { needToken: true, useRestEdge: true })
        } else {
          response = api.post(restEdge.createRoute, body, { needToken: true, useRestEdge: true })
        }

        this.saveLoading = false
        response.then(({ status }) => {
          if (status === 200) {
            this.showNotificationAlert('Success', 'Data successfully saved!', 'success')
            this.$router.push({ name: 'buschannel' })
          } else {
            this.showNotificationAlert('Error', 'Data failed to save', 'danger')
          }
        })
      }
    },
    async getFormOptions() {
      const { data, status, statusText } = await api.get(restEdge.getFormRoute, { needToken: true, useRestEdge: true })

      if (status === 200) {
        const { categories, interests, brands } = fromArrayKeys(data)
        this.options.categories = categories
        this.options.waypoints = interests
        this.options.brands = brands
        this.options.users = await data.user.map(user => ({ id: parseInt(user.id), label: user.email, title: user.email, value: user.id }))
      } else {
        this.showNotificationAlert('Error', statusText, 'danger')
      }

    },
    async getFormData() {
      const { data, status, statusText } = await api.get(restEdge.getOneRoute(this.routeId), { needToken: true, useRestEdge: true })

      if (status === 200) {
        this.model.route = data.title
        this.model.impression = data.impression
        this.model.distance = data.distance
        this.model.description = data.description
        this.model.category = data.category.id
        this.model.restriction = data.forbiddenAds
        this.model.brand = data.brand.id
        this.model.owner = data.owner.id

        if (data.fileRoute) {
          this.model.kmlFileId = data.fileRoute.id
          this.model.kmlFileData = data.fileRoute.id
          this.model.kmlFileName = data.fileRoute.content_url.split("/").pop()
        }

        this.model.waypointLocation = await data.routeDetails.map(wl => {
          this.vuelidateOptions.waypointLocation.error.push({ waypoint: null, location: null })
          return { waypoint: wl.pointInterest.id, location: wl.location }
        })

        if (!this.model.waypointLocation.length) this.model.waypointLocation.push({ waypoint: null, location: null })

        this.model.items = await data.buses.map(bus => {
          return {
            placements: bus.generic.title,
            quantity: bus.generic.quantity,
            active: bus.generic.isActive,
            public: bus.generic.isPublic,
          }
        })

        this.model.images = await data.contents.map(content => {
          return {
            id: content.id,
            name: content.content_name,
            image: content.content_url,
            isFeatured: content.is_featured,
            url: content.content_url
          }
        })

        if (!this.model.images.length) this.model.images.push({ id: null, name: null, image: null, isFeatured: null, url: null })
      } else {
        this.showNotificationAlert('Error', statusText, 'danger')
      }
    },
    buttonClicked(image) {
      this.model.images.map(img => {
        if (img.id !== image.id) img.isFeatured = false
      })
    },
    showWaypoint(event,index){
      let wayPointId = event && event.item ? event.item.id : null;
      if(wayPointId === 0 || !wayPointId) {
        let val = !this.isShowModalWayPoint[index];
        this.$set(this.isShowModalWayPoint, index, val);
      } else {
        this.isShowModalWayPoint[index] =  false;
      }
      this.waypointModel.newWaypoint = null;
      this.vuelidateWaypointOptions.newWaypoint.error = null;
    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
@import "~@/styles/variables";
@import "~@/styles/mixins";

.addRoute {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }

            .popup {
              &__input {
                max-width: 100%;
                margin-left: 48px;
              }
            }
          }
        }
      }
    }
  }

  .waypointWrapper {
    display: flex;
  }

  input {
    min-height: 62px;
  }

  .selectDropdown {
    .popup {
      max-height: 300px;
      overflow-y: auto;
    }
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 32px;
    height: 45px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }

  .title.large-font {
    font-size: 24px;
  }
}
</style>
